import PageTitle from "../../components/DefaultStyles/PageTitle";
import React, { useState, useEffect } from "react";
import NewUserLogFilter from "../../components/pages/NewUserLog/NewUserLogFilter";
import { atom, useRecoilState, useRecoilValue } from "recoil";
import { authType } from "../Login";
import { useApi } from "../../hooks/useApi";
import LineBox from "../../components/DefaultStyles/LineBox";
import Table, { TableBody, TableBodyItem } from "../../components/Table/Table";
import { ActLog } from "../../Enum/state.Enum";
import dayjs from "dayjs";
import SpaceBetween from "../../components/DefaultStyles/SpaceBetween";
import Pagination from "../../components/Table/Pagination";
import { TotalCount } from "../Users/UserInfo";
import { getThousandComma } from "../../ApiTS/ApiCommonTS";
import { useNavigate } from "react-router-dom";
import { toast } from "react-toastify";
import Loader from "../../components/DefaultStyles/Loader";
import { DashBoardDateFilterContainer } from "../../components/pages/Dashboard/UserBoard";
import DashBoardDateFilter from "../../components/pages/Dashboard/DashBoardDateFilter";
import NewUserLogDateFilter from "./NewUserLogDateFilter";

interface INewUserLog {
  uid: string;
  name: string;
  nickname: string;
  type: number;
  logdate: string;
  logdata?: any;
}

export const newUserLogFilterState = atom({
  key: "newUserLogFilterState",
  default: {
    searchType: "",
    searchValue: "",
    logType: "",
    page: 0,
  },
});

export default function NewUserLog() {
  const auth = useRecoilValue(authType);
  const navigate = useNavigate();
  const [filterDate, setFilterDate] = useState({
    startDate: dayjs().add(0, "day")?.format("YYYY-MM-DD") ?? "",
    endDate: dayjs().add(0, "day")?.format("YYYY-MM-DD") ?? "",
    isAccum: false,
  });

  const [filter, setFilter] = useRecoilState(newUserLogFilterState);
  const [page, setPage] = useState(filter?.page ?? 0);

  useEffect(() => {
    setFilter((prev) => ({ ...prev, page: 0 }));
  }, []);

  console.log(filter);

  const { response, loading, error } = useApi({
    method: "get",
    url: auth?.userLog
      ? `log?page=${page}&size=10` +
        (filter?.searchValue !== ""
          ? `&${filter?.searchType}=${filter?.searchValue}`
          : ``) +
        (filter?.logType !== "" ? `&type=${filter?.logType}` : ``) +
        `&startdate=${filterDate.startDate}&enddate=${filterDate.endDate}`
      : undefined,
  });

  const tableHead = ["UID_이름_닉네임", "로그 타입", "실행 시간", "내용"];

  useEffect(() => {
    if (error) {
      toast.error(error?.data ?? "유저 로그 조회에 실패했습니다.");
    }
  }, [error]);

  return (
    <>
      <PageTitle title="NEW 유저 로그" />

      <NewUserLogFilter pageResetEvent={() => setPage(0)} />
      <DashBoardDateFilterContainer>
        <NewUserLogDateFilter
          setFilter={setFilterDate}
          filter={filterDate}
          isAfter={{
            value: 31,
            unit: "day",
          }}
        />
      </DashBoardDateFilterContainer>
      {response?.status === 200 && (
        <LineBox>
          <Table tableHeadData={tableHead}>
            {response?.data?.items?.map((d: INewUserLog, i: number) => (
              <TableBody key={i}>
                <TableBodyItem
                  isKeepAll={true}
                  clickable={true}
                                    onClick={() => {
                    setFilter((prev) => ({ ...prev, page }));
                    navigate(`/users/info/${d?.uid}`);
                  }}
                >
                  {d?.uid}_{d?.name}_{d?.nickname}
                </TableBodyItem>
                <TableBodyItem isKeepAll={true}>
                  {ActLog[d?.type] ?? "-"}
                </TableBodyItem>
                <TableBodyItem isKeepAll={true}>
                  {dayjs(d?.logdate).format("YYYY-MM-DD HH:mm:ss")}
                </TableBodyItem>
                <TableBodyItem>
                  {Object.keys(d.logdata)[0] ? JSON.stringify(d?.logdata) : "-"}
                </TableBodyItem>
              </TableBody>
            ))}
          </Table>

          <SpaceBetween>
            <Pagination
              totalPage={response?.status === 200 ? response.data.totalPage : 1}
              currentPage={page}
              pageClickEvent={(index) => setPage(index)}
            />

            <TotalCount>
              총{" "}
              {getThousandComma(
                response?.status === 200 ? +response?.data?.totalCount : 0
              )}
              개
            </TotalCount>
          </SpaceBetween>
        </LineBox>
      )}

      {loading && <Loader />}
    </>
  );
}
